import { useQuery } from "@tanstack/react-query";
import { invoiceApi } from "@/lib/invoice.api";
import { queryKeys } from "@/lib/query-keys";
import { isValidRecordId } from "@/lib/route-id";

export function useInvoice(invoiceId: number) {
  return useQuery({
    queryKey: queryKeys.invoice(invoiceId),
    enabled: isValidRecordId(invoiceId),
    queryFn: () => invoiceApi.getById(invoiceId).then((r) => r.data),
  });
}
